<template>
  <div>
    <!--阅读协议-->
    <div v-show="current===1" class="pdTop10">
      <p class="tct pdBtm10" style="font-size: 3.1rem;border-bottom: 1px solid #eee;"
      >报名之前请认真阅读 “2021年各类成人高校招生须知”</p>
      <div class="pdTop10 pdBtm10" style="border-bottom: 1px solid #eee;">
        <p class="tct fs22" style="color: #337ab7">现场确认期间防疫要求</p>
        <div class="fs14 col666 box mrTop10" style="padding: 0 10rem;">
          1、考生要加强防疫知识学习，做好个人防护，避免人员聚集。确认前每日自觉进行体温测量、记录及健康状况监测，建议考生无特殊情况不要离鲁。<br/>
          2、考生须提前申领山东省电子健康通行码，持健康通行码（绿码）并经体温检测正常后方可进入确认场所，体温≥37.3℃的考生，需进行体温复测。体温复测后仍≥37.3℃，经专业评估和综合研判，能继续参加确认的，安排在备用确认场所完成确认。<br/>
          3、考生持健康通行码（非绿码）或为新冠肺炎确诊病例、无症状感染者、疑似患者、确认病例接触者，已治愈未超过14天的病例，确认前21天从高风险等级地区回鲁的、前14天从中风险等级地区回鲁的，居住社区21天内发生疫情的，确认前有发热（体温≥37.3℃）或其他呼吸道疾病症状的考生，务必前往本人确认所在市定点医疗机构作核酸检测。考生确认时应主动向确认点说明情况，并提供确认前7日内核酸检测合格证明。<br/>
          4、现场确认期间要做好个人防护。考生在进入确认场所前要佩戴口罩，除核验身份及拍照时不得摘下口罩。<br/>
          5、考生应排队有序入场和离场，尽量与他人保持安全距离。<br/>
        </div>
      </div>
      <div class="pdTop10 pdBtm10" style="border-bottom: 1px solid #eee;">
        <p class="tct fs22" style="color: #337ab7">考生诚信考试承诺书</p>
        <div class="fs14 col666 box mrTop10" style="padding: 0 10rem;">
          本人已仔细阅读2021年成人高等学校招生全国统一考试报名须知。本人郑重承诺：<br>
          1、所填写和提供的个人信息、证明材料、证件等真实、准确、有效，并符合所报专业的报名条件。<br>
          2、在报名考试过程中自觉遵守《考生守则》、《国家教育考试违规处理办法》、《刑法（修正案九）》的相关规定。如若违反，愿按照相关规定、法律接受处理。<br>
          3、对因提供有关材料信息不实、不符合报名资格、违反有关纪律规定和以上承诺所造成的后果本人自愿承担相应责任。<br>
        </div>
      </div>
      <div class="difcac pdTop20" v-if="!isSign">
        <el-button type="primary" @click="current=2" style="width: 120px;" :disabled="time>0">
          {{text}}<span v-if="time>0">({{time}}秒)</span>
        </el-button>
      </div>
      <div class="difcac pdTop20" v-else>
        <el-button type="primary" @click="goCheck()">
          已报名，点击查看
        </el-button>
      </div>
    </div>
    <!--填写资料-->
    <div v-show="current===2" class="pdTop10">
      <div class="tct fs24" style="color: #337ab7">填写基本信息</div>
      <!--填写基本信息和确认信息-->
      <div v-if="active===1 || active===2" style="margin-top: 4rem;">
        <!--填写基本信息-->
        <div class="warp">
          <h2 class="warp_title" style="font-size: 16px;">填写基本信息</h2>
          <el-row>
          <!--姓名-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">姓名</span>
            </div>
            <div class="mrLft20 w30">
              <el-input placeholder="请输入姓名" :disabled="is_disabled" v-model="name"></el-input>
            </div>
            <div class="mrLft20 w30">
              <span class="text-red">*</span>(限２０个汉字，中不留空，找不到的汉字以汉语拼音（半角大写字母）代替；少数民族考生姓名中若含有点请复制使用“·”)
            </div>
          </el-col>
          <!--民族-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">民族</span>
            </div>
            <div class="mrLft20 w30">
              <el-select v-model="nation" :disabled="is_disabled" style="width: 100%;">
                <el-option
                    v-for="(item,index) in nations" :key="index"
                    :label="item"
                    :value="item"
                ></el-option>
              </el-select>
            </div>
            <div class="mrLft20 w30">
              <span class="text-red">*</span>(少数民族执行加分照顾政策请咨询当地县级招生办公室)
            </div>
          </el-col>
          <!--性别-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">性别</span>
            </div>
            <div class="mrLft20 w30">
              <el-radio v-model="gender" label="1" :disabled="is_disabled">男</el-radio>
              <el-radio v-model="gender" label="2" :disabled="is_disabled">女</el-radio>
            </div>
          </el-col>
          <!--出生日期-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">出生日期</span>
            </div>
            <div class="mrLft20 w30">
              <el-date-picker
                  style="width: 100%;"
                  :disabled="is_disabled"
                  v-model="birth"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
            <div class="mrLft20 w30">
              <span class="text-red">*</span>(出生日期须与身份证一致，填写格式为：YYYY-MM-DD，截止到2021年12月31日未满18周岁考生确认时需提供高中同等学力毕业证书)
            </div>
          </el-col>
          <!--是否工作-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">是否工作</span>
            </div>
            <div class="mrLft20 w30">
              <el-radio v-model="is_work" label="1" :disabled="is_disabled">是</el-radio>
              <el-radio v-model="is_work" label="0" :disabled="is_disabled">否</el-radio>
            </div>
            <div class="mrLft20 w30">
              <span class="text-red">*</span>(少数民族执行加分照顾政策请咨询当地县级招生办公室)
            </div>
          </el-col>
          <!--身份证号-->
          <el-col :span="24" :xs="24" class="dif alc item">
            <div class="fs16  w20 trt">
              <span style="color: #EE2352">*</span>
              <span class="col101010" style="font-size: 14px;">身份证号</span>
            </div>
            <div class="mrLft20 w30">
              <el-input placeholder="请输入身份证号" maxlength="18" v-model="number" :disabled="is_disabled"></el-input>
            </div>
          </el-col>
          </el-row>
        </div>
        <!--填写联系方式-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写联系方式</h2>
          <el-row>
            <!--联系电话-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">接受短信手机号码</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入联系电话" v-model="tel" :disabled="is_disabled"></el-input>
              </div>
              <!--<div class="mrLft20 w30">-->
              <!--  <span class="text-red">*</span>(限２０个汉字，中不留空，找不到的汉字以汉语拼音（半角大写字母）代替；少数民族考生姓名中若含有点请复制使用“·”)-->
              <!--</div>-->
            </el-col>
            <!--户籍地址-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">户籍地址</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入户籍地址" v-model="huji" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
            <!--邮件地址-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">电子邮箱E-MAIL</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="电子邮箱E-MAIL" v-model="youjian" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                (没有可不填写)
              </div>
            </el-col>
            <!--邮寄地址-->
            <el-col :span="24" :xs="24" class="dif mrTop10">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">通知书邮寄地址</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入邮寄地址" v-model="youji" type="textarea" rows="5" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(不超过32个汉字)
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报考志愿-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写报考志愿</h2>
          <el-row>
            <!--目前学历-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">请选择文化程度</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="nowXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in nowXueliArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学历-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">请选择报考层次</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applyXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXueliArr"
                      :key="item.value"
                      :disabled="item.disabled"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(必须先选择文化程度)
              </div>
            </el-col>
            <!--报考学科-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考学科</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;"
                           @change="changeXk"
                           v-model="applyXueke" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXuekeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考专业-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考专业</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applyZhuanye" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyZhuanyeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学校-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考学校</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applySchool" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in schoolArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报名确认点-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写报名确认点</h2>
          <el-row>
            <!--考试地区-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">考试地区</span>
              </div>
              <div class="mrLft20 w30">
                <el-cascader
                    style="width: 100%;"
                    size="large"
                    :options="options"
                    v-model="area"
                    :disabled="is_disabled"
                    @change="setArea">
                </el-cascader>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(考生参加考试地区)
              </div>
            </el-col>
            <!--确认地点-->
            <el-col :span="24" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">确认地点</span>
              </div>
              <div class="mrLft20 w30">
                <el-cascader
                    style="width: 100%;"
                    size="large"
                    :options="options"
                    v-model="confirmAddress"
                    :disabled="is_disabled"
                    @change="setConfirm">
                </el-cascader>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>审查/照相/报名信息确认地点，报名成功后不允许修改
              </div>
            </el-col>
            <!--登录密码-->
            <el-col :span="24" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">登录密码</span>
              </div>
              <div class="mrLft20 w30">
                <el-input type="password" placeholder="请输入登录密码，限50字符" maxlength="50" v-model="password" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>请记住密码，查询录取名单时用到
              </div>
            </el-col>
            <!--指导老师-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">指导老师</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入指导老师姓名" :disabled="is_disabled" v-model="teacherName"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--重置和下一步-->
        <div class="mrTop30 button_warp">
          <!--<el-col :span="12" :xs="24" class="difcac">-->
          <!--  <div class="difcac button2 pointer" @click="reset()" v-if="active===1">重置</div>-->
          <!--  <div class="difcac button2 " style="opacity: 0;" v-if="active===2">上一步</div>-->
          <!--</el-col>-->
          <el-col :span="24" :xs="24" class="difcac">
            <div class="difcac button1 pointer" @click="submit()" v-if="active===1">提交信息</div>
            <div class="difcac button1 pointer" v-if="active===2" @click="showPay()">提交</div>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let timeout1 = null //定时器
import {regionData, CodeToText, TextToCode } from 'element-china-area-data' //地址插件
//返回顶部动画
const cubic = value => Math.pow(value, 3);
const easeInOutCubic = value => value < 0.5
    ? cubic(value * 2) / 2
    : 1 - cubic((1 - value) * 2) / 2;
export default {
  name: "startSign",
  data() {
    return {
      isSign: false,
      current: 1,//1阅读协议 2填写资料
      text:'我接受',
      time: 5,

      active: 1,//当前步骤
      options: regionData,
      value: '',
      nations: ["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族",
        "哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族",
        "土族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族", "乌孜别克族",
        "俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族","珞巴族","基诺族"],
      is_disabled: false,//是否禁用
      name: '',//姓名
      nation: '汉族',//民族
      gender: '1',//性别
      birth: '',//出生日期
      is_work: '1',//是否工作
      number: '',//身份证
      tel: '',//联系电话
      huji: '',//户籍地址
      youjian: '',//邮件地址
      youji: '',//邮寄地址
      nowXueli: '',//目前学历
      applyXueli: '',//报考学历
      applyZhuanye: '',//报考专业
      applyXueke: '',//报考学科
      xk: '',
      applySchool: '',//报考学校
      area: '',//考试地区
      area2: '',//考试地区
      confirmAddress: '',//确认地点
      confirmAddress2: '',//确认地点
      password: '',//登录密码
      teacherName: '',//指导老师姓名
      payImg: '',

      //滚动动画
      el: null,
      container: null,
      visible: false,

      //选择项
      nowXueliArr: [ //当前学历
        {value: '小学',label: '小学'},
        {value: '初中',label: '初中'},
        {value: '高中',label: '高中'},
        {value: '专科',label: '专科'},
      ],
      applyXueliArr: [ //报考学历
        {value: 1,label: '高起专',disabled: false},
        {value: 2,label: '高起本',disabled: false},
        {value: 3,label: '专升本',disabled: false},
      ],
      applyZhuanyeArr: [],//报考专业
      applyXuekeArr: [],//报考学科
      schoolArr: [],//报考学校

      //支付图片和金额
      price: '',
      ercode: '',
    }
  },
  methods: {
    goCheck() { //点击查看信息
      this.$router.push('/infoCenter/check').catch(err => err)
    },
    getUserInfo() { //获取用户信息，判断是否报名
      let user_id = JSON.parse(localStorage.getItem('jiaoyu')).id
      this.$axios("POST","/user/info",{user_id: user_id})
          .then(res => {
            if(res.code===1) {
              if(res.data.baoming_id) this.isSign = true
            }
          })
    },
    changeXk(e) {
      let obj = this.applyXuekeArr.find((item)=>{
        return item.id===e
      })
      this.xk = obj.name
    },
    startTime() { //开始计时
      clearInterval(timeout1);
      let that = this
      timeout1 = setInterval(()=>{
        this.time--
        if(this.time<=0) {
          clearInterval(timeout1)
        }
      },1000)
    },
    getLogoTitle() {
      this.$axios("POST","/index/cms_system",{})
          .then(res => {
            if(res.code===1) {
              this.logo = res.data.image
              this.title = res.data.title
            }
          })
    },
    init() { //初始化滚动
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.container = document;
      this.el = document.documentElement;
      if (this.target) {
        this.el = document.querySelector(this.target);
        if (!this.el) {
          throw new Error(`target is not existed: ${this.target}`);
        }
        this.container = this.el;
      }
    },
    scrollToTop() { //回到顶部 动画
      const el = this.el;
      const beginTime = Date.now();
      const beginValue = el.scrollTop;
      const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
      const frameFunc = () => {
        const progress = (Date.now() - beginTime) / 500;
        if (progress < 1) {
          el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
          rAF(frameFunc);
        } else {
          el.scrollTop = 0;
        }
      };
      rAF(frameFunc);
    },
    prev() { //上一步
      this.scrollToTop()
      this.active = 1
      this.is_disabled = false
    },
    reset() { //重置

    },
    submit() { //提交信息
      if(this.name==='') {
        this.$alert('请输入姓名')
        return
      }else if(this.birth==='') {
        this.$alert('请选择出生日期')
        return;
      }else if(this.number==='') {
        this.$alert('请输入身份证号')
        return
      }else if(this.tel==='') {
        this.$alert('请输入联系电话')
        return
      }else if(this.huji==='') {
        this.$alert('请输入户籍地址')
        return
      }else if(this.youjian==='') {
        this.$alert('请输入邮件地址')
        return
      }else if(this.youji==='') {
        this.$alert('请输入邮寄地址')
        return
      }else if(this.nowXueli==='') {
        this.$alert('请选择目前学历')
        return;
      }else if(this.applyXueli==='') {
        this.$alert('请选择报考学历')
        return;
      }else if(this.applyXueke==='') {
        this.$alert('请选择报考学科')
        return;
      }else if(this.applyZhuanye==='') {
        this.$alert('请选择报考专业')
        return
      }else if(this.applySchool==='') {
        this.$alert('请选择报考学校')
        return
      }else if(this.area2==='') {
        this.$alert('请选择考试地区')
        return
      }else if(this.confirmAddress2==='') {
        this.$alert('请选择确认地点')
        return
      }else if(this.password==='') {
        this.$alert('请输入登录密码')
        return
      }else if(this.teacherName==='') {
        this.$alert('请输入指导老师')
        return
      }
      this.$confirm('如信息填写有误，请联系老师进行修改')
          .then(res => {
            /*this.active = 2
            this.scrollToTop()
            this.is_disabled = true*/
            this.paySubmit()
          })
    },
    showPay() { //确认信息，并跳到第三步
      this.scrollToTop()
      this.active = 3
    },
    paySubmit() { //提交支付
      let info = JSON.parse(localStorage.getItem('jiaoyu'))
      let data = {
        name: this.name,
        mz: this.nation,
        sex: this.gender,
        is_gz: this.is_work,
        date_time: this.birth,
        idcard: this.number,
        tel: this.tel,
        address: this.huji,
        email: this.youjian,
        email_address: this.youji,
        xueli: this.nowXueli,
        bk_xl: this.applyXueli,
        zhuanye_id: this.applyZhuanye,
        xk: this.xk,
        school_id: this.applySchool,
        ks_address: this.area2,
        qr_address: this.confirmAddress2,
        password: this.password,
        teacher: this.teacherName,
        member_id: info.id,
        image: this.payImg,
        add_time: '',
        type: this.applyXueli,
      }
      this.$axios("POST","/index/bm",data,'提交中')
          .then(res => {
            if(res.code===1) {
              this.$alert('报名成功')
                  .then( six => {
                    this.$router.push('/infoCenter/check').catch(err => err)
                  })
            }else {
              this.$alert(res.msg)
            }
          })
    },
    onsuccess(e) { //上传图片成功回调
      console.log('上传成功',e);
      this.payImg = e.data
    },
    getPayInfo() { //获取付款信息
      this.$axios("POST","/index/pay",{})
          .then(res => {
            if(res.code===1) {
              this.price = res.data.pay_amount
              this.ercode = res.data.pay_image
            }
          })
    },
    getZhuanye(xk_id) { //获取报考专业
      this.$axios("POST","/index/zhuanye_list",{xk_id},'加载中')
          .then(res => {
            if(res.code===1) {
              this.applyZhuanyeArr = res.data
            }
          })
    },
    getXueKe(pname) { //获取学科
      this.$axios("POST","/index/xk_list",{pname},'加载中')
          .then(res => {
            if(res.code===1) {
              this.applyXuekeArr = res.data
            }
          })
    },
    getSchool(pname) { //获取学校
      this.$axios("POST","/index/school_list",{pname})
          .then(res => {
            if(res.code===1) {
              this.schoolArr = res.data
            }
          })
    },
    setArea(e) { //选择考试地区
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.area2 = `${p},${c},${a}`
    },
    setConfirm(e) { //选择确认地点
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.confirmAddress2 = `${p},${c},${a}`
    },
  },
  mounted() {
    this.init();
    this.startTime();
    this.getUserInfo();
  },
  watch: {
    nowXueli(newValue) { //选择目前学历
      if(newValue==='专科') {
        this.applyXueliArr[0].disabled = true
        this.applyXueliArr[1].disabled = true
        this.applyXueliArr[2].disabled = false
        this.applyXueli = 3
      }else {
        this.applyXueliArr[0].disabled = false
        this.applyXueliArr[1].disabled = false
        this.applyXueliArr[2].disabled = true
        this.applyXueli = 1
      }
    },
    applyXueli(newValue) { //选择学历获取学科
      this.getXueKe(newValue)
    },
    applyXueke(newValue) { //选择学科获取专业
      this.getZhuanye(newValue)
    },
    applyZhuanye(newValue) { //根据专业id获取学校
      this.getSchool(newValue)
    },
  }
}
</script>

<style scoped>
  .bg{
    width: 100%;
    /*background: #00B7A4;*/
  }
  .sign_up{
    width: 80%;
    margin: 0 auto;
    background: #FFFFFF;
  }
  .router{
    padding: 2rem;
    box-sizing: border-box;
  }
  .warp{
    width: 100%;
    background: #E5FFFA;
    box-sizing: border-box;
    padding: 2rem;
  }
  .warp_title{
    color: #00B7A4;
    padding-bottom: 2rem;
    border-bottom: 1px solid #929393;
  }
  .logo_warp{
    position: absolute;
    top: 5rem;
    z-index: 22;
    left: 4rem;
  }
  .site_title{
    font-weight: bold;
    color: #FFFFFF;
    font-size: 4rem;
  }
  .logo_warp img{
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    background: #FFFFFF;
  }
  .item{
    height: 60px;
    box-sizing: border-box;
  }
  .w70{
    width: 50%;
  }
  .button2{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #BBBBBB;
    color: #101010;
  }
  .button1{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #4eac4e;
    color: #FFFFFF;
  }
  .button_warp{
    height: 120px;
  }
  .code{
    width: 22rem;
    height: 22rem;
    background: #cbcbcb;
    margin-top: 5rem;
    margin-bottom: 3.5rem;
  }
  .upLoad{
    width: 12rem;
    height: 12rem;
    background-color: rgba(0, 0, 0, 0.02);
    cursor: pointer;
  }
  @media (max-width: 768px) {
    .sign_up{
      width: 100%;
    }
    .w70{
      width: 70%;
    }
    .button1{
      margin-top: 10px;
    }
    .button_warp{
      height: 150px;
    }
  }
</style>